import {
  Component,
  OnInit,
  ChangeDetectorRef,
  Input,
  Output,
  EventEmitter,
  OnDestroy
} from '@angular/core';
import Recorder from 'recorder-js';
import { FileUploadService } from '../../core/file-upload.service';
import { environment } from '../../../../environments/environment';
import { AlertService } from '../../services/alert.service';
import { AuthService } from '../../services/auth.service';

@Component({
  selector: 'app-voice-recorder',
  templateUrl: './voice-recorder.component.html',
  styleUrls: ['./voice-recorder.component.scss']
})
export class VoiceRecorderComponent implements OnInit, OnDestroy {
  @Input() filename: string;
  @Input() enableRecorder = false;
  @Input() viewType = 'buttons';
  @Output() recorded: EventEmitter<Blob> = new EventEmitter<Blob>();
  @Output() send: EventEmitter<any> = new EventEmitter<any>();

  RecorderFlash: any;
  RecorderHtml5: Recorder;
  AudioContext: any;
  Audio: any;
  isRecording = false;
  blob = null;
  time = '0:00';
  hiddenFlashContainer = false;

  recording = false;
  playing = false;

  constructor(
    private fileUploadService: FileUploadService,
    private alertService: AlertService,
    private cd: ChangeDetectorRef
  ) {}

  ngOnInit() {
    if (this.useFlashRecorder()) {
      //  this.InitRecorderFlash();
    } else {
    }
  }

  ngOnDestroy() {
    if (this.AudioContext) {
      this.AudioContext.close();
    }
  }

  useFlashRecorder() {
    return !window.navigator.mediaDevices;
  }

  recordSound() {
    this.filename = null;

    if (this.recording) {
      if (this.useFlashRecorder()) {
        this.stopFlash();
      } else {
        this.stopHtml5();
      }
    } else {
      if (this.useFlashRecorder()) {
        this.InitRecorderFlash();

        this.recordFlash();
      } else {
        this.recordHtml5();
      }
    }
  }

  playSound() {
    if (this.useFlashRecorder()) {
      if (this.filename) {
        window.open(this.filename);
      } else {
        this.playFlash();
      }
    } else {
      this.playHtml5();
    }
  }

  private InitRecorderHtml5() {
    this.AudioContext = new (window['AudioContext'] ||
      window['webkitAudioContext'])();

    this.RecorderHtml5 = new Recorder(this.AudioContext, {
      onAnalysed: data => {
        // console.log(data);
      }
    });
  }

  private InitRecorderFlash() {
    if (!this.RecorderFlash) {
      this.RecorderFlash = window['RecorderFlash'];

      this.RecorderFlash.initialize({
        swfSrc: 'assets/vendors/js/recorderflash/recorderf.swf',
        flashContainer: document.getElementById('flash_rec'),
        onFlashSecurity: () => {
        }
      });
    }
  }

  timecode(ms) {
    const hms = {
      h: Math.floor(ms / (60 * 60 * 1000)),
      m: Math.floor((ms / 60000) % 60),
      s: Math.floor((ms / 1000) % 60)
    };
    const tc = []; // Timecode array to be joined with '.'

    if (hms.h > 0) {
      tc.push(hms.h);
    }

    tc.push(hms.m < 10 && hms.h > 0 ? '0' + hms.m : hms.m);
    tc.push(hms.s < 10 ? '0' + hms.s : hms.s);

    return tc.join(':');
  }

  sendSound() {
    const item: any = {
      blob: this.blob,
      RecorderFlash: this.RecorderFlash
    };

    this.send.emit(item);
  }

  private recordHtml5() {
    this.InitRecorderHtml5();

    console.log('html 5 - recording');
    setTimeout(f => {
      window.navigator.mediaDevices
        .getUserMedia({ audio: true })
        .then(stream => {
          this.RecorderHtml5.init(stream);
          this.RecorderHtml5.start().then(() => (this.recording = true));
        })
        .catch(err =>
          this.alertService.showError('Unable to get stream... ', 'Error')
        );
    }, 300);
  }

  private recordFlash() {

    setTimeout(() => {
      this.recording = true;
      this.RecorderFlash.record({
        progress: milliseconds => {
          // this.time = this.timecode(milliseconds);
          // this.cd.detectChanges();
        }
      });
    }, 1000);
  }

  private stopHtml5() {
    console.log('html 5 - stop');
    this.RecorderHtml5.stop().then(({ blob, buffer }) => {
      this.blob = blob;
      this.recorded.emit(this.blob);
    });
    this.recording = false;
    this.AudioContext.close();
  }

  private stopFlash() {
    this.hiddenFlashContainer = true;
    this.cd.detectChanges();

    this.RecorderFlash.stop();
    if (!this.RecorderFlash.audioData()) {
      return;
    }
    const builder = new MSBlobBuilder();
    builder.append(this.RecorderFlash.audioData());
    const myBlob = builder.getBlob('audio/wav');
    this.blob = myBlob;
    this.recording = false;
    this.recorded.emit(this.blob);
  }

  private playFlash() {
    /*const builder = new MSBlobBuilder();
    builder.append(this.RecorderFlash.audioData());
    const myBlob = builder.getBlob('audio/wav');
*/

    if (this.playing) {
      this.RecorderFlash.stop();
    }
    this.playing = true;
    this.cd.detectChanges();
    this.RecorderFlash.play({
      finished: () => {
        console.log('playFlash finished');
        this.playing = false;
        this.cd.detectChanges();
      }
    });
  }

  private playHtml5() {
    this.playing = true;
    this.Audio = new Audio();
    this.Audio.addEventListener('ended', f => {
      this.playing = false;
    });
    this.Audio.src = this.filename
      ? this.filename
      : window.URL.createObjectURL(this.blob);

    this.Audio.addEventListener('error', f => {
      this.alertService.showError(
        'An unhandled exception occurred while loading sound file.'
      );
      this.playing = false;
    });
    this.Audio.addEventListener('ended', f => {
      this.playing = false;
    });
    this.Audio.load();
    this.Audio.play();
  }
}



// WEBPACK FOOTER //
// E:/proj/news12/zb-n12/scadmin/client/src/app/shared/components/voice-recorder/voice-recorder.component.ts